import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SystemConfigService } from '@core/configs/system-config.service';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'pn-footer',
    standalone: true,
    imports: [CommonModule, SvgIconComponent, RouterModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    animations: [
        trigger('expandState', [
            state('expanded', style({ height: '*', marginTop: '*' })),
            state('collapsed', style({ height: '0', marginTop: 0 })),
            transition('expanded <=> collapsed', [animate('250ms cubic-bezier(0.65,0.05,0.36,1)')]),
        ]),
    ],
})
export class FooterComponent {
    public expanded = 0;
    public readonly commonConfig = this._systemConfig.commonConfig;

    constructor(private readonly _systemConfig: SystemConfigService) {}
}
